/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import { Asset, BadgeType, EntryPoint } from '@wit/vtv-x-foundation-lib';
import RailBadgeEngine from 'core/services/core/badgeEngine/RailBadgeEngine';
import { StoreState } from 'store/store';

export const Selector = {
  getAssetsWithBadges: (
    store: StoreState,
    badgesPriorities: Array<BadgeType[]>,
    assetsSelector: (store: StoreState) => Asset[] | undefined,
    entryPoint?: EntryPoint
  ) => RailBadgeEngine.getAssetsWithBadgesListFromRail(assetsSelector(store) || [], badgesPriorities, entryPoint),
};
